import { useEffect, useRef, useState } from "react";

export function CountUp({ value, decimals = 0, duration = 700 }) {
  const [n, setN] = useState(0);
  const raf = useRef();

  useEffect(() => {
    const to = Number(value) || 0;
    const start = performance.now();
    cancelAnimationFrame(raf.current);
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(to * eased);
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration]);

  return (
    <>{n.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}</>
  );
}
